import React from 'react';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import ComponentIdBadge from '../../components/ui/ComponentIdBadge';

export default function Login() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4 relative">
      <ComponentIdBadge 
        id="pg-login-main" 
        name="Login Page"
        description="User authentication page with email/password login"
        position="top-right"
      />
      
      <div className="max-w-md w-full space-y-8">
        <div className="relative">
          <ComponentIdBadge 
            id="cmp-login-header" 
            name="Login Page Header"
            description="Logo and welcome message section"
            position="inline"
            showLabel={true}
          />
          <LoginHeader />
        </div>
        
        <div className="relative bg-white rounded-2xl shadow-xl p-8">
          <ComponentIdBadge 
            id="frm-login-main" 
            name="Login Form Component"
            description="Email and password authentication form"
          />
          <LoginForm />
        </div>

        <div className="relative">
          <ComponentIdBadge 
            id="cmp-security-badges" 
            name="Security Trust Badges"
            description="Security and compliance indicators"
            position="inline"
          />
          <SecurityBadges />
        </div>
      </div>
    </div>
  );
}